import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  getLoansByEnterpriseId,
  getLoansByUserId
} from "../../actions/loan.action";
import Table, { TableColumns } from "../../components/table";
import { RetailODDetails, TermLoanDetails, UserLoanDetails } from "../../dto";
import dispatch from "../../middleware";
import { LoanType, RoutePaths } from "../../models";
import { ReduxState } from "../../reducers";
import { dateToDDMMYYYY, isLoadingActive } from "../../utils";
import { isUserAnEnterprise } from "./helpers";

interface UserLoansProps {
  userId: string;
}

export default function UserLoans({ userId }: UserLoansProps) {
  const storeDispatch = useDispatch();
  const loadingQueue = useSelector(
    (state: ReduxState) => state.loan.loadingQueue,
  );
  const loans: UserLoanDetails = useSelector(
    (state: ReduxState) => state.loan.userLoans,
  );

  const isEnterprise = isUserAnEnterprise(userId);

  useEffect(() => {
    dispatch(
      storeDispatch,
      isEnterprise ? getLoansByEnterpriseId(userId) : getLoansByUserId(userId),
    );
  }, []);

  const retailODColumns: TableColumns[] = [
    { field: "_id", label: "Loan ID" },
    { field: "appId", label: "Application ID" },
    { field: "createdAt", label: "Date of Loan" },
    { field: "maxAmount", label: "Sanctioned Amount" },
    // { field: "loanType", label: "Loan Type" },
    // { field: "irpa", label: "IRPA (%)" },
    // { field: "pf", label: "PF" },
  ];

  const termLoanColumns: TableColumns[] = [
    { field: "_id", label: "Loan ID" },
    { field: "appId", label: "Application ID" },
    { field: "createdAt", label: "Date of Loan" },
    { field: "approvedAmount", label: "Approved Amount" },
    { field: "tenureInMonths", label: "Tenure (months)" },
    // { field: "loanType", label: "Loan Type" },
    // { field: "irpa", label: "IRPA (%)" },
    // { field: "pf", label: "PF" },
  ];

  function getIdLink(path: RoutePaths, id: string) {
    return (
      <Link to={`${path}/${id}`} className="table-link">
        {id}
      </Link>
    );
  }
  function getLoanType(type: LoanType) {
    if (type === "RETAIL_OD") return "Earned Wage Access";
    if (type === "TERM_LOAN") return "Term Loan";
    return "";
  }
  function getTableDataForTerm(loans: TermLoanDetails[]) {
    return loans.map(
      ({
        _id,
        appId,
        loanType,
        irpa,
        pf,
        approvedAmount,
        tenureInMonths,
        createdAt,
      }) => ({
        _id: getIdLink(RoutePaths.PERSONAL_LOANS, _id),
        appId: getIdLink(RoutePaths.APPLICATIONS, appId),
        createdAt: dateToDDMMYYYY(createdAt ?? ""),
        approvedAmount,
        tenureInMonths,
        // loanType: getLoanType(loanType),
        // irpa,
        // pf,
        // action: <Button variant="info">View</Button>,
      }),
    );
  }
  function getTableDataForOD(loans: RetailODDetails[]) {
    return loans.map(
      ({ _id, appId, loanType, irpa, pf, maxAmount, createdAt, tenor }) => ({
        _id: getIdLink(RoutePaths.PERSONAL_LOANS, _id),
        appId: getIdLink(RoutePaths.APPLICATIONS, appId),
        maxAmount,
        tenor: 12,
        createdAt: dateToDDMMYYYY(createdAt) ?? "-",

        // loanType: getLoanType(loanType),
        // irpa,
        // pf,
        // emiStartDate: dateToDDMMYYYY(emiStartDate),
        // action: <Button variant="info">View</Button>,
      }),
    );
  }
  return (
    <>
      <div className="d-flex flex-row justify-content-between mb-4">
        <div className="user-page-title">Earned Wage Access Drawdowns</div>
      </div>
      <Table
        loading={isLoadingActive(loadingQueue)}
        columns={retailODColumns}
        data={getTableDataForOD(loans.retailODs)}
      />
      <div className="mb-4">
        <h3 className="user-page-title">Term Loans</h3>
      </div>
      <Table
        loading={isLoadingActive(loadingQueue)}
        columns={termLoanColumns}
        data={getTableDataForTerm(loans.termLoans)}
      />
    </>
  );
}
